<template>
    <div id="roleSection">
        <card>
            <Row id="operation">
                <Button type="primary" @click="add" size="small">新增</Button>
            </Row>
            <Table :columns="columns" :data="data" :loading="dataLoading"></Table>
            <Page :total="pageTotalNum" :current="pageCurrent" v-if="showPager" show-elevator show-total
                  @on-change="changePage"></Page>
        </card>
        <role-form ref="RoleForm" v-on:close="onCloseForm"></role-form>
    </div>
</template>
<script>
    import RoleForm from './form.vue';

    export default {
        name: 'setting_role',
        data () {
            return {
                columns: [
                    {
                        title: '角色名称',
                        key: 'name'
                    },
                    {
                        title: '角色代码',
                        key: 'code'
                    },
                    {
                        title: '角色状态',
                        key: 'state',
                        render: (h, params) => {
                            if (params.row.state == 1){
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'primary'
                                        },
                                    },'正常');
                            }else{
                                return h('Tag',
                                    {
                                        props: {
                                            color: 'error'
                                        },
                                    },'禁用');
                            }

                        }
                    },
                    {
                        title: '操作',
                        render: (h, params) => {
                            let self = this;

                            let opArray = [];

                            opArray.push(h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.$refs.RoleForm.showWin(params.row.id);
                                    }
                                }
                            }, '修改'));

                            opArray.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        self.$Modal.confirm({
                                            title: '提示',
                                            content: '是否确定删除？',
                                            onOk: () => {
                                                self.$api.role.del({id:params.row.id}).then(resp => {
                                                    if (resp.state == 'ok'){
                                                        self.$Message.info('删除成功');
                                                        self.getList();
                                                    }else{
                                                        self.$Message.error(resp.msg);
                                                    }
                                                });
                                            },
                                            onCancel: () => {

                                            }
                                        });
                                    }
                                }
                            }, '删除'));


                            return h('div',opArray);
                        }
                    }
                ],
                data: [],
                dataLoading: false,
                ruleInline: {

                },
                totalPage:0,
                pageTotalNum:0,
                pageCurrent:1
            }
        },
        computed: {
            showPager : function(){
                return this.totalPage > 1
            }
        },
        methods: {
            getList(){
                this.dataLoading = true;
                let param = {
                    p:this.pageCurrent
                }
                this.$api.role.getList(param).then(resp => {
                    this.data = resp.data.list;
                    this.pageTotalNum = resp.data.totalRow;
                    this.totalPage = resp.data.totalPage;
                    this.pageCurrent = resp.data.pageNumber;
                    this.dataLoading = false;
                });
            },
            add(){
                this.$refs.RoleForm.showWin();
            },
            changePage (page) {
                this.pageCurrent = page;
                this.getList();
            },
            doSearch(){
                this.pageCurrent = 1;
                this.getList();
            },
            onCloseForm(){
                this.getList();
            }
        },
        mounted: function () {
            this.getList();
        },
        components: {
            RoleForm
        }
    }
</script>
